/* file description */

// table的模式
export enum SPTableBaseMode {
  // 只读模式
  VIEW = 'view',
  // 可编辑模式，支持增删改查，也是常规默认模式
  EDIT = 'edit',
}
